import { createFileRoute } from '@tanstack/react-router';
import { settingsSearchSchema } from 'src/modules/settings/schemas/settings.schema';
import { IntegrationsSettingsPage } from 'src/modules/settings/components/pages/integrations-settings.page';

export const Route = createFileRoute('/settings/integrations/')({
  component: IntegrationsSettingsPage,
  validateSearch: (search) => settingsSearchSchema.parse(search),
});
